import { API_VERSION } from '@/apis/constants';
import { GetReportCfvEmissionsDataEntryRes } from '@/apis/report/cfv/emissions/data-entry.dto';
import { Api } from '@/typings/api';
import { ApiMethod, ApiService, buildUrl } from '@/utils/api';
import Request from '@/utils/Request';

import {
  GetReportCfvEmissionsDataCollectionParams,
  // [PLOP ANCHOR] dtoImport
} from './data-collection.dto';

const request = Request.getInstance().request;

export const getReportCfvEmissionsDataCollectionUrl = () =>
  buildUrl({
    service: ApiService.REPORT,
    version: API_VERSION[ApiService.REPORT],
    path: `/cfv/emissions/data_collection`,
  });
// [PLOP ANCHOR] apisUrl

export const getReportCfvEmissionsDataCollection: Api<
  GetReportCfvEmissionsDataCollectionParams,
  GetReportCfvEmissionsDataEntryRes
> = (payload) =>
  request({
    url: getReportCfvEmissionsDataCollectionUrl(),
    method: ApiMethod.GET,
    params: payload.query,
  });

// [PLOP ANCHOR] apisDefinition
